import React from "react";
import { FormattedMessage } from "react-intl";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { TVehicle } from "types";

import Button from "@mui/material/Button";
import { HashLink } from "react-router-hash-link";

import FinanceDetail from "../Finance/Detail/Detail";
import { Tupel } from "components";

import { ConfigurationStore } from "stores";
import Share from "../Share";
import { TQuality } from "components/EnVKV";

import { useSmartPath } from "helper/SmartLink";

interface ISummary {
  paperProps?: any;
  vehicle: TVehicle;
  financeFilter: any;
  financeRate: any;
  configuration: any;
  quality?: TQuality;
}

export const Summary: React.FC<ISummary> = ({
  paperProps = { sx: { p: 2 } },
  vehicle,
  financeFilter,
  financeRate,
  configuration,
  quality,
}): JSX.Element | null => {
  const smartPath = useSmartPath();

  if (!configuration) return null;
  const { modell } = vehicle;

  let hideButtonToContact = false;
  if (
    configuration.application?.router &&
    configuration.application.router === "hash"
  ) {
    hideButtonToContact = false;
  }

  return (
    <Paper
      data-testid="page-detail component-summary"
      variant="outlined"
      {...paperProps}
    >
      {!!configuration.features?.share && (
        <Box sx={{ position: "relative" }}>
          <Share
            sx={{ position: "absolute", top: 0, right: 0 }}
            vehicle={vehicle}
          />
        </Box>
      )}
      <Typography
        component="h2"
        variant="h5"
        sx={{
          width: 0.9,
          textOverflow: "ellipsis",
          overflow: "hidden",
          wordWrap: "no-break",
        }}
      >
        {modell.marke.name} {modell.name}
      </Typography>
      <Typography
        gutterBottom
        component="h3"
        variant="h6"
        sx={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          wordWrap: "no-break",
        }}
      >
        {vehicle.version}
      </Typography>
      <FinanceDetail {...{ vehicle, financeRate }} short />
      <Tupel
        labelId="filter.aufbau.label"
        textId={`aufbau.${vehicle.aufbau.id}.label`}
        property="bodyType"
      />
      <Tupel
        labelId="filter.fzart.label"
        textId={`fzart.${vehicle.fzart.id}.label`}
        property="itemCondition"
      />
      <Tupel labelId="common.offerNumber" text={vehicle.wgnr} />
      <Box sx={{ mt: 4, textAlign: "center" }}>
        {!!configuration.features?.checkout === true && (
          <Button variant="contained">
            <FormattedMessage
              id="common.buyCar"
              defaultMessage="Fahrzeug kaufen"
            />
          </Button>
        )}
        {!hideButtonToContact && (
          <Button
            variant="contained"
            component={HashLink}
            to={smartPath("") + "#Offer"}
            color="primary"
            sx={{ ml: 3 }}
          >
            <FormattedMessage
              id="pages.detail.offer.title"
              defaultMessage="Fahrzeug anfragen"
            />
          </Button>
        )}
      </Box>
    </Paper>
  );
};

interface IPipeline extends Omit<ISummary, "configuration"> {}

const Pipeline: React.FC<IPipeline> = (props): JSX.Element | null => {
  const configuration = React.useContext(ConfigurationStore);

  return <Summary {...{ ...props, configuration }} />;
};

export default Pipeline;
